import React, { useEffect, useState } from "react";
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import {
    deleteItem,
    loadPopupMessages,
} from "../utils/Network";
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { isAdmin } from "../utils";

export default function PopupMessageList({ page, urlParams }) {
  const [loading, setLoading] = useState(0);
  const [pageloading, setPageLoading] = useState(false);
  const [data, setData] = useState(null);
  const [show_delete, setShowDelete] = useState(false);
  const [count, setCount] = useState(null);
  const [pages, setPages] = useState(null);

  var filter_query = window.location.search;

  useEffect(() => {
    setPageLoading(true);
    getData();

  }, []);

  function getData() {
    //console.log(filter_query)
    loadPopupMessages(filter_query, page).then((data) => {
      if (data.results) {
        setData(data.results);
      }
      if (data.count) {
        if (data && data.count) {
          setCount(data.count);
          var page_count =
            data.count % 10 === 0
              ? parseInt(data.count / 10)
              : parseInt(data.count / 10) + 1;
          var pages_array = range(1, page_count);
          setPages(pages_array);
        }
      }
      setPageLoading(false);
    });
  }
  function range(start, end) {
    return Array.apply(0, Array(end)).map((element, index) => index + start);
  }

  const handleDelete = (id, e) => {
    setLoading(id);
    deleteItem('postapi/popupmessage',id).then(() => {
      getData();
    });
  };

  const showDelete = (e) => {
    e.preventDefault();
    setShowDelete(!show_delete);
  };



  return (
    <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <div className="content-wrapper">
                  <section class="content-header">
                    <h3 class="box-title mt-5"></h3>
                    <ol class="breadcrumb">
                      <li>
                        <a href="dashboard">
                          <i class="fa fa-dashboard"></i> Home
                        </a>
                      </li>
                      <li class="active">Popup Messages</li>
                    </ol>
                  </section>

                  <section className="content">
                    <div className="row">
                      <div className="col-md-12">
                        <div class="box box-primary">
                          <div class="box-header with-border">
                            <h3 class="box-title mt-5">
                              Popup Message &nbsp;
                              <small>({count}) items</small>
                            </h3>
                            {isAdmin() && (
                              <>
                                <a
                                  href="popupmessage/"
                                  title="Add New"
                                  className="btn btn-orange pull-right "
                                >
                                  <i className="fa fa-plus"></i>
                                </a>
                                <a
                                  href="#"
                                  title="Show Delete Button"
                                  className="btn btn-danger margin-r-5 pull-right "
                                  onClick={showDelete}
                                >
                                  <i className="fa fa-trash"></i>
                                </a>
                              </>
                            )}
                          </div>
                          <div className="box-body no-padding ">
                            <form action="" method="get">
                              <DragDropContext >
                                <table id="example1" className="table table-striped mb-0">
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th>Description</th>
                                      <th>Date</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <Droppable droppableId={"dopaable"}>
                                    {(drop_provided) => (
                                      <tbody
                                        ref={drop_provided.innerRef}
                                        {...drop_provided.dropableProps}
                                      >
                                        {data &&
                                          data.map((item, index) => (
                                            <>
                                              <Draggable
                                                key={item.id}
                                                draggableId={`${item.id}`}
                                                index={index}
                                              >
                                                {(provided) => (
                                                  <tr
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    ref={provided.innerRef}
                                                    className={
                                                      loading === item.id
                                                        ? "jd loading "
                                                        : "jd"
                                                    }
                                                  >
                                                    <td>
                                                      <a href={`popupmessage/${item.id}`}>
                                                        <img src={item.image} alt="" className="width-100"  />
                                                      </a>
                                                    </td>
                                                    <td>{item.description}</td>
                                                    <td>
                                                      {item.created_at.split("T")[0]}
                                                      <br />
                                                      {
                                                        item.created_at
                                                          .split("T")[1]
                                                          .split(".")[0]
                                                      }
                                                    </td>
                                                    <td>
                                                      <div className="btn-group">
                                                        {show_delete && (
                                                          <button
                                                            type="button"
                                                            onClick={(e) => {
                                                              if (
                                                                window.confirm(
                                                                  "Are you sure you wish to delete this item?"
                                                                )
                                                              )
                                                                handleDelete(item.id, e);
                                                            }}
                                                            className="btn btn-default btn-sm"
                                                          >
                                                            <i className="fa fa-trash"></i>
                                                          </button>
                                                        )}
                                                        <a
                                                          href={`popupmessage/${item.id}`}
                                                          className="btn btn-default btn-sm"
                                                        >
                                                          <i className="fa fa-edit"></i>
                                                        </a>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )}
                                              </Draggable>
                                            </>
                                          ))}
                                      </tbody>
                                    )}
                                  </Droppable>
                                </table>
                              </DragDropContext>
                            </form>
                          </div>
                        </div>

                        <ul className="pagination cms-pagination m-0 float-right">
                          <li className="page-item">
                            <Link className="page-link" to="#">
                              «
                            </Link>
                          </li>
                          {pages &&
                            pages.map((page_number) => (
                              <li key={page_number} className="page-item">
                                <a
                                  className={
                                    page_number == page ? "page-link active" : "page-link"
                                  }
                                  href={`popupmessages/${page_number}${
                                    urlParams ? "?" + urlParams : ""
                                  }`}
                                >
                                  {page_number}
                                </a>
                              </li>
                            ))}
                          <li className="page-item">
                            <Link className="page-link" to="">
                              »
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </section>
                </div>
                <Footer />
    </div>
  );
}
